import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';
import creatorsUpdaters, {BulkEnqueuedResponse} from '@/api/updaters/creators';
import {recruitmentsQueryKey} from '@/hooks/queries/use-recruitments-query';

export type RecruitAllToCrmVariables = {
  agencyId: string;
  searchSessionId: string;
};

function useRecruitAllToCrm(): UseMutationResult<
  BulkEnqueuedResponse,
  Error,
  RecruitAllToCrmVariables
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['creators', 'recruitAllToCrm'],
    mutationFn: creatorsUpdaters.recruitAllToCrm,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [recruitmentsQueryKey]});
    },
  });
}

export default useRecruitAllToCrm;
